import { Exception } from '@src/types';

import _ from 'lodash';

/**
 *  An EventHandle is meant to be used as a handle for a remote Event. The handle will be informed
 *  whenever the event is started and can also trigger the event remotely.
 *
 *  @param eventStarted
 *
 *  Example usage:
 *      // Output: 1 2 3 4
 *      var printSomething = (promise) => {
 *          console.info("2");
 *          promise.then(function() {
 *              console.info("3");
 *          });
 *      };
 *      var eventHandle = new EventHandle(printSomething);
 *
 *      var eventFunction = () => {
 *          console.info("1");
 *          return Promise.resolve();
 *      };
 *      eventHandle.registerEventFunction(eventFunction);
 *
 *      eventHandle.triggerEvent().then(() => {
 *          console.info("4");
 *      });
 *
 */
export class EventHandle {
    private readonly eventCallback;
    private eventFunction;

    constructor(eventCallback?) {
        this.eventCallback = eventCallback;
        this.eventFunction = null;
    }

    public registerEventFunction(eventFunction) {
        if (!_.isFunction(eventFunction)) {
            throw new Exception({ message: 'Provided eventFunction is not a function.' });
        }
        this.eventFunction = eventFunction;
    }

    public triggerEvent() {
        if (!_.isFunction(this.eventFunction)) {
            return Promise.reject(new Exception({ message: 'No event process has been registered.' }));
        }

        const promise = Promise.resolve(this.eventFunction());
        if (_.isFunction(this.eventCallback)) {
            this.eventCallback(promise);
        }
        return promise;
    }
}
